import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class ApiKeyInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const apiKey = environment.apiKey;

    let headers = req.headers.append('X-API-KEY', apiKey);

    // Attach the JWT bearer token (set at login) so endpoints that resolve the
    // current account server-side (e.g. /external/payments/*) can authenticate.
    const token = this.getToken();
    if (token && req.url.startsWith(environment.apiUrl)) {
      headers = headers.append('Authorization', `Bearer ${token}`);
    }

    return next.handle(req.clone({ headers }));
  }

  private getToken(): string | null {
    const raw = window.localStorage.getItem('appToken');
    if (!raw) {
      return null;
    }
    // LocalStorageService stores values JSON-stringified, so the token is quoted.
    try {
      return JSON.parse(raw);
    } catch {
      return raw;
    }
  }
}
